import React from 'react';
import { Th, Box } from '@chakra-ui/react';
import { TriangleUpIcon, TriangleDownIcon } from '@chakra-ui/icons';

interface TableHeaderProps<T> {
  label: string;
  sortKey: keyof T;
  sortConfig: {
    key: keyof T | null;
    direction: 'asc' | 'desc' | null;
  };
  onSort: (key: keyof T) => void;
}

export function TableHeader<T>({ label, sortKey, sortConfig, onSort }: TableHeaderProps<T>) {
  return (
    <Th 
      cursor="pointer"
      onClick={() => onSort(sortKey)}
      _hover={{ bg: 'gray.50' }}
      /* Responsive padding & font: compact on mobile, default on desktop */
      px={{ base: 2, md: 4 }}
      py={{ base: 1.5, md: 3 }}
      fontSize={{ base: '0.68rem', md: 'xs' }}
      whiteSpace="nowrap"
    >
      <Box display="inline-flex" alignItems="center" gap="4px">
        {label}
        <Box width="12px" display="inline-block">
          {sortConfig.key === sortKey && (
            sortConfig.direction === 'asc' ? 
              <TriangleUpIcon boxSize={2} /> : 
              sortConfig.direction === 'desc' ? 
                <TriangleDownIcon boxSize={2} /> : 
                null
          )}
        </Box>
      </Box>
    </Th>
  );
} 